import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[markantPlatformOutsideClick]',
})
export class OutsideClickDirective {
  @Output()
  outsideClick = new EventEmitter<{ type: 'mouse' | 'keyboard' }>();

  private readonly elementRef = inject(ElementRef);

  @HostListener('document:mousedown', ['$event'])
  onMouseDown(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit({ type: 'mouse' });
    }
  }

  @HostListener('window:keydown.esc', ['$event'])
  onKeyEscDown(event: KeyboardEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.outsideClick.emit({ type: 'keyboard' });
    }
  }
}
